import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FunctionsService } from 'src/app/___LOGIC/__common/functions.service';
import { PdfManagerService } from 'src/app/___LOGIC/__pdf/pdf-manager.service';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {

  // DOCU
  //https://www.codexworld.com/embed-pdf-document-file-in-html-web-page/

  @Input() pdfFile;

  pdfId;

  show = false;

  pdfLinks = [
    {
      url: 'assets/pdf/empadronamiento/hojaPadronal.pdf'
    }
  ];

  constructor(private commonFunctions: FunctionsService,private route: ActivatedRoute,private pdfManager: PdfManagerService,private router: Router) {
  }

  ngOnInit(): void {
    if(this.router.url.startsWith('/pdf-guide-view/')){
      if(this.pdfManager.isLinkValid()){
        this.pdfId = this.pdfManager.currentPdf;
      }else{
        this.router.navigateByUrl('home');
      }
    }else{
      this.pdfId = this.route.snapshot.paramMap.get('id');
      this.pdfManager.setCurrentPdfId(this.pdfId);
    }
  }

  getPdfBody(){
    switch(this.pdfId){
      case 'mapaMetroMadrid':
        return 'https://docs.google.com/viewer?url=https://app.voyjaleas.com/voyjaleasResources/pdf/transport/mapaMetroMadrid.pdf&embedded=true';
      case 'mapaMetroBarcelona':
        return 'https://docs.google.com/viewer?url=https://app.voyjaleas.com/voyjaleasResources/pdf/transport/mapaMetroBarcelona.pdf&embedded=true';
      case 'mapaMetroValencia':
        return 'https://docs.google.com/viewer?url=https://app.voyjaleas.com/voyjaleasResources/pdf/transport/mapaMetroValencia.pdf&embedded=true';
      // ACCOMMODATION
      case 'guiaMadridHospedaje':
        /* return 'https://docs.google.com/viewer?url=https://voyjaleas-pdf-worker.sebtec12.workers.dev/acc-FREE-HospedajeMadrid-LargaDuración.pdf&embedded=true'; */
        return 'https://voyjaleas-pdf-worker.sebtec12.workers.dev/acc-FREE-HospedajeMadrid-LargaDuracion.pdf';
      case 'hojaPadronal':
        return 'https://docs.google.com/viewer?url=https://app.voyjaleas.com/voyjaleasResources/pdf/empadronamiento/hojaPadronal.pdf&embedded=true';
      case 'guiaAltaPadron':
          return 'https://docs.google.com/viewer?url=https://app.voyjaleas.com/voyjaleasResources/pdf/empadronamiento/guiaAltaPadronMadrid.pdf&embedded=true';
      case 'condicionesSeguro':
        return 'https://docs.google.com/viewer?url=https://app.voyjaleas.com/voyjaleasResources/pdf/omnibus/condicionesAsisa.pdf&embedded=true';
      case 'formularioVisado':
        return 'https://docs.google.com/viewer?url=https://app.voyjaleas.com/voyjaleasResources/pdf/visa/FORMULARIO_SOLICITUD_VISADO.pdf&embedded=true';
      case 'formularioAsisa':
          return 'https://docs.google.com/viewer?url=https://app.voyjaleas.com/voyjaleasResources/pdf/omnibus/Formulario-Solicitud_ASISA.pdf&embedded=true';
      case 'cuestionarioAsisa':
          return 'https://docs.google.com/viewer?url=https://app.voyjaleas.com/voyjaleasResources/pdf/omnibus/Cuestionario-de-Salud_ASISA.pdf&embedded=true';
      default:
        // PAID GUIDES
        return this.pdfId;
        break;
    }
  }

  getPdfToRender(){
    if(!this.pdfFile){
      this.pdfFile = this.commonFunctions.convertUrl(this.getPdfBody());
    }
    return this.pdfFile;
  }
  
  photoURL() {
    // Sanitize URL
    if(!this.pdfFile){
      // default
      if(this.getPdfLink(0)){
        this.pdfFile = this.commonFunctions.convertUrl(this.getPdfLink(0).url);
      }else{
        this.pdfFile = this.commonFunctions.convertUrl('assets/voyjaleas/pdf/empadronamiento/hojaPadronal.pdf');
      }
    }else{
      this.pdfFile = this.commonFunctions.convertUrl(this.pdfFile);
    }
    return this.pdfFile;
  }

  getPdfLink(id){
    return this.pdfLinks[id];
  }

}